



































































































import { Component, Vue } from 'vue-property-decorator'
import { Helper } from '@/helpers/Helper'
import PageHead from '@/components/PageHead.vue'
import { Notify } from '@/helpers/Notify'
import { Api } from '@/fetch/Api'
import store from '@/store'
import axios from 'axios'

@Component({
  components: {
    PageHead,
  },
})
export default class RightSideBar extends Vue {
  pageTitle = 'Files & Images'
  callInProgress = false
  selectedFile = null
  selectedFileSrc = null
  domainImages = null
  domainFiles = null
  imageUploaded = false
  pdfUploaded = false
  fileSelected = null
  // base_url: Helper.getCurrentDomain()
  urlScheme = window.location.protocol

  get Helper() {
    return Helper
  }

  mounted() {
    this.fetchDoaminImages()
  }

  public onFileSelected(event) {
    this.fileSelected = event.target.files[0].name
    if (event.target.files.length) {
      switch (event.target.files[0].type) {
        case 'image/png':
        case 'image/svg':
        case 'image/gif':
        case 'image/jpeg':
          this.imageUploaded = true
          this.pdfUploaded = false
          break

        case 'application/pdf':
          this.imageUploaded = false
          this.pdfUploaded = true
          break
      }

      this.selectedFileSrc = URL.createObjectURL(event.target.files[0])
      this.selectedFile = event.target.files[0]
      // this.selectedFile = this.$refs.file.files[0]
    }
  }

  public async uploadImage() {
    this.callInProgress = true
    axios.defaults.baseURL = Api.getBaseUrl()
    const formData = new FormData()
    formData.append('image', this.selectedFile, this.selectedFile.name)
    formData.append('image_source', '1')
    try {
      // COULDN'T GET THIS WORKING FOR SOME REASON, WILL REVISIT TO FIX.
      // await Api.uploadImage(this.selectedFile)
      axios.post('/domain/image', formData).then(response => {
        const showError = 'error' in response.data && response.data.error === 1
        this.callInProgress = false
        store.commit('toggleFlag')
        this.fetchDoaminImages()
        // console.log(showError)
        if (showError) {
          Notify.create({
            type: 'error',
            title: 'File Upload Error',
            text: response.data.message,
          })
        } else {
          Notify.create({
            type: 'success',
            title: 'Saved!',
            text: 'Image Saved. Reload page if you can not see the image that was uploaded.',
          })
        }
      })
    } catch (e) {
      this.callInProgress = false
      Notify.create({
        type: 'error',
        title: 'Something went wrong...',
        text: e,
      })
    }
  }

  public async deleteImage(imageId) {
    this.$bvModal.msgBoxConfirm('Are you sure you want to delete this image? This will break portions of your website where this image is still in use!', {
      title: 'Heads Up! ',
      size: 'md',
      buttonSize: 'md',
      okVariant: 'danger',
      okTitle: 'Proceed',
      cancelTitle: 'Cancel',
      footerClass: 'p-2',
      hideHeaderClose: false,
      centered: true,
    })
      .then(value => {
        if (value) {
          try {
            const deleteImageResponse = Api.deleteDomainImage(imageId)
            this.fetchDoaminImages()
            Notify.create({
              type: 'success',
              title: 'Saved!',
              text: 'Image Deleted. Reload page if you are still able to see the image.',
            })
          } catch (e) {
            this.callInProgress = false
            Notify.create({
              type: 'error',
              title: 'Something went wrong...',
              text: e,
            })
          }
        }
      })
      .catch(err => {
        // An error occurred
        console.log(err)
      })
  }

  public async fetchDoaminImages() {
    this.callInProgress = true
    try {
      const domainImagesResponse = await Api.getDomainImages()
      this.domainImages = domainImagesResponse.domainImages
      this.domainFiles = domainImagesResponse.domainFiles
      this.callInProgress = false
    } catch (e) {
      this.callInProgress = false
      Notify.create({
        type: 'error',
        title: 'Something went wrong...',
        text: e,
      })
    }
  }

  public async copyImageUrl(imageUrl) {
    navigator.clipboard.writeText(imageUrl)
    Notify.create({
      type: 'info',
      title: '',
      text: 'Copied!',
    })
  }

  public async goToUrl(fileUrl) {
    window.open(fileUrl, '_blank')
  }
}
